import PerLinkAnalytics from "@/components/PerLinkAnalytics";
import BucketAnalytics from "@/components/BucketAnalytics";

export default function PartnerAnalyticsPage() {
    return (
        <div className="space-y-8 max-w-6xl">
            <div>
                <h1 className="text-2xl font-bold tracking-tight">Per-link Analytics</h1>
                <p className="text-sm text-slate-500 mt-1">
                    Volume, conversion, top UPI app and top customer for each of your payment links.
                </p>
            </div>
            <PerLinkAnalytics path="/partner/analytics/per-link" scope="partner"
                              upgradeCta="This is a Pro tier feature. Contact your account manager to enable per-link analytics." />

            {/* iter-66: bucket hit-rate — separate section, no gating, no
                paywall. Cheap to compute and directly actionable. */}
            <div className="border-t border-slate-100 pt-6">
                <BucketAnalytics />
            </div>
        </div>
    );
}
